import React from 'react';
import InputMask from 'react-input-mask';

const MaskedInput = ({id, mask, value, onChange, className, readOnly, autoComplete = "on"}) =>{
    return <InputMask autoComplete={autoComplete} id={id} mask={mask} value={value} onChange={onChange} className={className} readOnly={readOnly}></InputMask>;
};

export default MaskedInput;